import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { TREASURY_ENV } from "../../config/micros-env.tokens";
import { EnvMicroTreasury } from "../../config/env.micro.treasury";
import { CashFlowIncome } from "../../../domain/models/accounting/cash-flow.model";
import { CashFlowPort } from "../../../app/ports/accounting/cash-flow.port";
import { toCashFlowIncome } from "../../validators/accounting/cash-flow.validator";

const INVALID_INCOME = "La respuesta de los ingresos del cash flow es inválida.";

@Injectable()
export class CashFlowHttpAdapter implements CashFlowPort {
  private static readonly INCOME_PATH = "/api/v1/cash-flow/income";

  constructor(
    private readonly http: HttpClient,
    @Inject(TREASURY_ENV) private readonly env: EnvMicroTreasury,
  ) {}

  income(companyCode: string, currencyCode: string, yearMonth?: string): Observable<CashFlowIncome> {
    let params = new HttpParams().set("companyCode", companyCode).set("currencyCode", currencyCode);
    if (yearMonth) params = params.set("yearMonth", yearMonth);
    return this.http
      .get<unknown>(`${this.baseUrl()}${CashFlowHttpAdapter.INCOME_PATH}`, { params })
      .pipe(
        map((response) => {
          const income = toCashFlowIncome(response);
          if (!income) throw new Error(INVALID_INCOME);
          return income;
        }),
      );
  }

  private baseUrl(): string {
    return `${this.env.host}${this.env.apiBasePath}`.replace(/\/$/, "");
  }
}
